import PropTypes from "prop-types";
import { Drawer, Button, Space, Upload } from "antd";
import { message } from "../../components/antdMessageBridge";
import { CloseCircleOutlined } from "@ant-design/icons";
import FileUploadIcon from "../../assets/img/svg/xfileuploadicon.svg?react";
import { getUTCDate } from "../../components/utcDate";
import CommonObj from "../../CommonObj";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import { useAuth } from "../../auth/AuthContext";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";

const SliderUI = (props) => {
  const loadingKey = "Uploading";
  const { accessToken } = useAuthToken();
  const { roleUserId } = useAuth();

  const beforeUpload = (file) => {
    const isTxt = file.type === "text/plain";
    if (!isTxt) {
      message.error(`${file.name} is not a TXT file`);
      return Upload.LIST_IGNORE;
    }
    const isLt6M = file.size / 1024 / 1024 < 6;
    if (!isLt6M) {
      message.error("File must be smaller than 6MB");
      return Upload.LIST_IGNORE;
    }
    return isTxt && isLt6M;
  };

  const handelUpload = async (file) => {
    const actualFile = file.originalFileObj || file;
    const isTxt = actualFile.file.type === "text/plain";
    if (!isTxt) {
      message.error(`${file.name} is not a TXT file`);
      return Upload.LIST_IGNORE;
    }
    const formData = new FormData();
    formData.append("file", actualFile.file);

    try {
      const myHeaders = {
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
      };
      const startTime = getUTCDate();
      const response = await fetch(
        CommonObj.Endpoints.uploadDeliveryS3 +
          `?StartTime=${startTime?.UTCDate}&LastModifiedBy=${roleUserId}`,
        {
          method: "POST",
          headers: myHeaders,
          body: formData,
        }
      );

      if (response.ok) {
        message.success({
          content: "Book delivery status has been updated successfully.",
          key: loadingKey,
          duration: 2,
        });
        props.onClose(true);
      } else {
        message.error({
          content:
            "Unable to update the status of the books. Please try again.",
          key: loadingKey,
          duration: 2,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error({
        content: "An error occurred. Please try again.",
        key: "rejecting",
        duration: 2,
      });
    }
  };

  return (
    <Drawer
      title={
        props.mode === "batch"
          ? `Book listed for the batch processing (${
              props.batchData.length < 10
                ? "0" + props.batchData.length
                : props.batchData.length
            })`
          : props.bookTitle
      }
      placement={props.placement}
      onClose={props.onClose}
      open={props.visible}
      width={props.width}
      className={props.className}
      closeIcon={<CloseCircleOutlined />}
      extra={
        <Space>
          <div className="relative">
            {props.bookscover === false ? (
              <button className="comments-header-status-notification">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.5"
                    d="M13.635 6.0295L13.9826 5.68192C14.5585 5.10603 15.4922 5.10603 16.0681 5.68192C16.644 6.25781 16.644 7.19151 16.0681 7.7674L15.7205 8.11498M13.635 6.0295C13.635 6.0295 13.6785 6.7681 14.3302 7.41982C14.9819 8.07153 15.7205 8.11498 15.7205 8.11498M13.635 6.0295L10.4396 9.22496C10.2231 9.4414 10.1149 9.54962 10.0218 9.66894C9.91205 9.80969 9.81793 9.96199 9.74113 10.1231C9.67603 10.2597 9.62763 10.4049 9.53084 10.6953L9.22094 11.625L9.12068 11.9258M15.7205 8.11498L12.525 11.3104C12.3086 11.5269 12.2004 11.6351 12.0811 11.7282C11.9403 11.8379 11.788 11.9321 11.6269 12.0089C11.4903 12.074 11.3451 12.1224 11.0547 12.2192L10.125 12.5291L9.82422 12.6293M9.82422 12.6293L9.52344 12.7296C9.38054 12.7772 9.223 12.74 9.11649 12.6335C9.00998 12.527 8.97279 12.3695 9.02042 12.2266L9.12068 11.9258M9.82422 12.6293L9.12068 11.9258"
                    stroke="#009DDB"
                    strokeWidth="1.125"
                  />
                  <path
                    opacity="0.5"
                    d="M6 9.75H7.875"
                    stroke="#009DDB"
                    strokeWidth="1.125"
                    strokeLinecap="round"
                  />
                  <path
                    opacity="0.5"
                    d="M6 6.75H10.875"
                    stroke="#009DDB"
                    strokeWidth="1.125"
                    strokeLinecap="round"
                  />
                  <path
                    opacity="0.5"
                    d="M6 12.75H7.125"
                    stroke="#009DDB"
                    strokeWidth="1.125"
                    strokeLinecap="round"
                  />
                  <path
                    d="M2.25 7.5C2.25 4.67157 2.25 3.25736 3.12868 2.37868C4.00736 1.5 5.42157 1.5 8.25 1.5H9.75C12.5784 1.5 13.9926 1.5 14.8713 2.37868C15.75 3.25736 15.75 4.67157 15.75 7.5V10.5C15.75 13.3284 15.75 14.7426 14.8713 15.6213C13.9926 16.5 12.5784 16.5 9.75 16.5H8.25C5.42157 16.5 4.00736 16.5 3.12868 15.6213C2.25 14.7426 2.25 13.3284 2.25 10.5V7.5Z"
                    stroke="#0009E2"
                    strokeWidth="1.125"
                  />
                </svg>
              </button>
            ) : (
              ""
            )}
            {!props.bookscover ? (
              <div className="grid-comments-button-container">
                <button className="comments-header-status-notification">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.15 6.69802L15.5362 6.31182C16.1761 5.67194 17.2135 5.67194 17.8534 6.31182C18.4933 6.95169 18.4933 7.98914 17.8534 8.62902L17.4672 9.01522M15.15 6.69802C15.15 6.69802 15.1983 7.51869 15.9224 8.24282C16.6466 8.96694 17.4672 9.01522 17.4672 9.01522M15.15 6.69802L11.5995 10.2485C11.359 10.489 11.2388 10.6093 11.1354 10.7418C11.0134 10.8982 10.9088 11.0675 10.8235 11.2465C10.7511 11.3983 10.6974 11.5596 10.5898 11.8823L10.2455 12.9152L10.1341 13.2494M17.4672 9.01522L13.9167 12.5657C13.6762 12.8062 13.556 12.9265 13.4234 13.0299C13.267 13.1519 13.0978 13.2564 12.9187 13.3418C12.767 13.4141 12.6056 13.4679 12.283 13.5754L11.25 13.9198L10.9158 14.0312M10.9158 14.0312L10.5816 14.1426C10.4228 14.1955 10.2478 14.1542 10.1294 14.0358C10.0111 13.9175 9.96976 13.7424 10.0227 13.5836L10.1341 13.2494M10.9158 14.0312L10.1341 13.2494"
                      stroke="#002449"
                    />
                    <path
                      d="M6.66797 10.8319H8.7513"
                      stroke="#002449"
                      strokeLinecap="round"
                    />
                    <path
                      d="M6.66797 7.49988H12.0846"
                      stroke="#002449"
                      strokeLinecap="round"
                    />
                    <path
                      d="M6.66797 14.1678H7.91797"
                      stroke="#002449"
                      strokeLinecap="round"
                    />
                    <path
                      opacity="0.5"
                      d="M2.5 8.33451C2.5 5.19182 2.5 3.62047 3.47631 2.64416C4.45262 1.66785 6.02397 1.66785 9.16667 1.66785H10.8333C13.976 1.66785 15.5474 1.66785 16.5237 2.64416C17.5 3.62047 17.5 5.19182 17.5 8.33451V11.6678C17.5 14.8105 17.5 16.3819 16.5237 17.3582C15.5474 18.3345 13.976 18.3345 10.8333 18.3345H9.16667C6.02397 18.3345 4.45262 18.3345 3.47631 17.3582C2.5 16.3819 2.5 14.8105 2.5 11.6678V8.33451Z"
                      stroke="#002449"
                    />
                  </svg>
                </button>
                <span className="comments-header-status-notification-count">
                  {props?.commentsCount < 10
                    ? "0" + props?.commentsCount
                    : props?.commentsCount}
                </span>
              </div>
            ) : null}
          </div>
        </Space>
      }
    >
      <div>
        <div className="mb-4"></div>
        <div className="fileupload-container">
          <Upload
            accept=".txt"
            multiple={false}
            maxCount={1}
            customRequest={handelUpload}
            beforeUpload={beforeUpload}
            showUploadList={false}
          >
            <Button type="primary" icon={<FileUploadIcon />}>
              Upload File <span className="linkClass">Choose File</span>
            </Button>
            <div className="fileupload-container-footer-text">
              <p>6 MB Max | Supported File Type : txt</p>
            </div>
          </Upload>
        </div>
      </div>
    </Drawer>
  );
};

SliderUI.propTypes = {
  mode: PropTypes.string,
  batchData: PropTypes.arrayOf(PropTypes.object),
  bookTitle: PropTypes.string,
  placement: PropTypes.oneOf(["right", "left", "top", "bottom"]), 
  onClose: PropTypes.func.isRequired, 
  visible: PropTypes.bool.isRequired, 
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  bookscover: PropTypes.bool, 
  commentsCount: PropTypes.number,
};

SliderUI.defaultProps = {
  mode: "",
  batchData: [],
  bookTitle: "",
  placement: "right",
  width: 500,
  className: "",
  bookscover: false,
  commentsCount: 0,
};

export default SliderUI;